export const texts = {
  title: {
    de: 'Neue Stelle',
    en: 'New position'
  },
  howTransfer: {
    de: 'Wie möchtest du die Stelle übergeben?',
    en: 'How would you like to submit the position?'
  },
  link: {
    de: 'Link',
    en: 'Link'
  },
  text: {
    de: 'Text',
    en: 'Text'
  },
  file: {
    de: 'Datei',
    en: 'File'
  },
  linkLabel: {
    de: 'Link zur Stellenanzeige',
    en: 'Link to the job ad'
  },
  textLabel: {
    de: 'Text der Stellenanzeige',
    en: 'Text of the job ad'
  },
  next: {
    de: 'Weiter',
    en: 'Continue'
  },
  loading: {
    de: 'Bitte warte kurz, während deine Stelle analysiert wird. Es dauert nicht mehr lange...',
    en: 'Please wait a moment while your position is analyzed. It won’t take much longer...'
  },
  error: {
    de: 'Es gab leider einen Fehler beim Laden der Stelle. Das Team von skillconomy wird die Ursache nun untersuchen und sich dann bei dir melden.',
    en: 'Unfortunately there was an error loading the position. The skillconomy team will investigate the cause and get back to you.'
  },
  tryAgain: {
    de: 'Nochmal versuchen',
    en: 'Try again'
  }
};
